import * as RadixTabs from '@radix-ui/react-tabs';
import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function Tabs({
  value,
  onValueChange,
  children,
  className,
}: {
  value: string;
  onValueChange: (v: string) => void;
  children: ReactNode;
  className?: string;
}) {
  return (
    <RadixTabs.Root value={value} onValueChange={onValueChange} className={className}>
      {children}
    </RadixTabs.Root>
  );
}

export function TabsList({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <RadixTabs.List
      className={cn(
        'flex items-center gap-1 border-b border-line px-2',
        className,
      )}
    >
      {children}
    </RadixTabs.List>
  );
}

export function TabsTrigger({ value, children }: { value: string; children: ReactNode }) {
  return (
    <RadixTabs.Trigger
      value={value}
      className={cn(
        'relative px-3 py-2.5 text-body-strong text-ink-muted',
        'hover:text-ink transition-colors',
        'data-[state=active]:text-navy data-[state=active]:font-semibold',
        'data-[state=active]:after:absolute data-[state=active]:after:left-3 data-[state=active]:after:right-3',
        'data-[state=active]:after:-bottom-px data-[state=active]:after:h-0.5 data-[state=active]:after:bg-navy',
      )}
    >
      {children}
    </RadixTabs.Trigger>
  );
}

export function TabsContent({ value, children }: { value: string; children: ReactNode }) {
  return (
    <RadixTabs.Content value={value} className="outline-none">
      {children}
    </RadixTabs.Content>
  );
}
